// extracted by mini-css-extract-plugin
export default {"content":"ReactModalWrap_content__-ok9K","collapseButton":"ReactModalWrap_collapseButton__k2gzw"};